// extracted by mini-css-extract-plugin
module.exports = {"varSpUp1":"1.25rem","container":"container--daa38","icon":"icon--a8bd5"};